import React from 'react';
import {
  Avatar,
  Box,
  Divider,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material';
import {
  Person as UserIcon,
  Hotel as HotelIcon,
  Lock as LockIcon,
  ExitToApp as ExitIcon,
} from '@mui/icons-material';
import {
  getShellMenuItemSx,
  getShellMenuPaperSx,
  getShellMenuUserHeaderSx,
} from '../../utils/mobileShellMenuLayout';
import { getProfileAvatarSx } from '../../utils/profilePageLayout';

const menuFocusProps = {
  autoFocus: false,
  disableAutoFocusItem: true,
  disableRestoreFocus: true,
  MenuListProps: { autoFocusItem: false },
};

const ProfileDesktopMenu = ({
  anchorEl,
  open,
  onClose,
  isDark,
  user = {},
  onMyProfile,
  onSwitchHotel,
  onLockScreen,
  onLogout,
  showSwitchHotel = false,
}) => {
  const displayName = user.fullName || user.username || 'User';
  const initial = (displayName[0] || 'U').toUpperCase();

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      {...menuFocusProps}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      sx={{ zIndex: 1600 }}
      PaperProps={{
        sx: {
          ...getShellMenuPaperSx(isDark),
          width: 240,
          borderRadius: '12px',
          padding: '8px 0',
          marginTop: '8px',
        },
      }}
    >
      <Box sx={getShellMenuUserHeaderSx(isDark)}>
        <Avatar sx={{ ...getProfileAvatarSx(isDark, 'menu'), border: 'none', boxShadow: 'none' }}>
          {initial}
        </Avatar>
        <Box sx={{ minWidth: 0 }}>
          <Typography sx={{ fontSize: '14px', fontWeight: 700, color: isDark ? '#f8fafc' : '#212121', lineHeight: 1.25 }}>
            {displayName}
          </Typography>
          <Typography sx={{ fontSize: '12px', color: isDark ? 'rgba(148,163,184,0.95)' : '#646777', lineHeight: 1.3 }}>
            {user.email || ''}
          </Typography>
        </Box>
      </Box>

      <Divider sx={{ borderColor: isDark ? 'rgba(255,255,255,0.08)' : 'rgb(223, 227, 235)' }} />

      <MenuItem onClick={onMyProfile} sx={{ ...getShellMenuItemSx(isDark), height: 40, px: 2 }}>
        <ListItemIcon>
          <UserIcon sx={{ fontSize: '18px' }} />
        </ListItemIcon>
        <ListItemText primary="My Profile" primaryTypographyProps={{ fontSize: '14px', fontWeight: 600 }} />
      </MenuItem>

      {showSwitchHotel && onSwitchHotel ? (
        <MenuItem onClick={onSwitchHotel} sx={{ ...getShellMenuItemSx(isDark), height: 40, px: 2 }}>
          <ListItemIcon>
            <HotelIcon sx={{ fontSize: '18px' }} />
          </ListItemIcon>
          <ListItemText primary="Switch Hotel" primaryTypographyProps={{ fontSize: '14px', fontWeight: 600 }} />
        </MenuItem>
      ) : null}

      <MenuItem onClick={onLockScreen} sx={{ ...getShellMenuItemSx(isDark), height: 40, px: 2 }}>
        <ListItemIcon>
          <LockIcon sx={{ fontSize: '18px' }} />
        </ListItemIcon>
        <ListItemText primary="Lock Screen" primaryTypographyProps={{ fontSize: '14px', fontWeight: 600 }} />
      </MenuItem>

      <Divider sx={{ borderColor: isDark ? 'rgba(255,255,255,0.08)' : 'rgb(223, 227, 235)' }} />

      <MenuItem
        onClick={onLogout}
        sx={{
          ...getShellMenuItemSx(isDark),
          height: 40,
          px: 2,
          color: isDark ? '#fecaca' : '#b91c1c',
          '& .MuiListItemIcon-root': { color: isDark ? '#f87171' : '#b91c1c' },
          '& .MuiListItemText-primary': { color: isDark ? '#fecaca' : '#b91c1c' },
        }}
      >
        <ListItemIcon>
          <ExitIcon sx={{ fontSize: '18px' }} />
        </ListItemIcon>
        <ListItemText primary="Log Out" primaryTypographyProps={{ fontSize: '14px', fontWeight: 600 }} />
      </MenuItem>
    </Menu>
  );
};

export default ProfileDesktopMenu;
